import { ApiRequestConfig } from 'api';
import { get } from 'features/api';
import { FetchProductCharacteristicsProps, FetchProductCharacteristicsResponse } from '../types';

export const fetchProductC14s = (props: FetchProductCharacteristicsProps, options: ApiRequestConfig) => {
  return get<FetchProductCharacteristicsResponse>('get-characteristics', { ...props }, options);
};
